export const SUBMIT_STATES = {
  IDLE: 'IDLE',
  VALIDATING: 'VALIDATING',
  SUBMITTING: 'SUBMITTING',
  RATE_LIMITED_RETRYING: 'RATE_LIMITED_RETRYING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

export function isSubmitInFlight(state) {
  return state === SUBMIT_STATES.VALIDATING
    || state === SUBMIT_STATES.SUBMITTING
    || state === SUBMIT_STATES.RATE_LIMITED_RETRYING;
}

export function canStartSubmit(state) {
  return !isSubmitInFlight(state);
}

export function getSubmitButtonLabel(state, orderStatus) {
  if (state === SUBMIT_STATES.VALIDATING) return 'Validating...';
  if (state === SUBMIT_STATES.SUBMITTING || state === SUBMIT_STATES.RATE_LIMITED_RETRYING) return 'Submitting...';
  if (orderStatus === 'Submitted') return 'Resubmit Order';
  return 'Submit Order';
}

export function buildSubmitSuccessMessage(result = {}) {
  if (result.retries > 0) {
    return 'Order successfully submitted after HubSpot became available again.';
  }
  return 'Order successfully submitted.';
}

export function buildSubmitFailureMessage(error) {
  const data = error?.response?.data || error || {};
  const correlationId = data.correlationId ? ` Reference: ${data.correlationId}.` : '';
  if (data.status === 'ALREADY_SUBMITTING') {
    return `This order is already being submitted. Please wait for the current submission to finish.${correlationId}`;
  }
  if (data.status === 'RATE_LIMITED') {
    return `HubSpot is temporarily busy. Automatic retries were not able to complete the submission yet. The order was not fully submitted.${correlationId}`;
  }
  return `The order was not fully submitted. Please try again or contact support.${correlationId}`;
}